type ShouldHideEditCharacterMenuItemOptions = {
  isCharacterOwner: boolean;
  isGroupCharacter: boolean;
  isGroupChatManageAllowed: boolean;
};

const shouldHideEditCharacterMenuItem = ({
  isCharacterOwner,
  isGroupCharacter,
  isGroupChatManageAllowed,
}: ShouldHideEditCharacterMenuItemOptions): boolean => {
  if (!isCharacterOwner) return true;
  return isGroupCharacter && !isGroupChatManageAllowed;
};

export default shouldHideEditCharacterMenuItem;
